import { render, staticRenderFns } from "./divBorder.vue?vue&type=template&id=4b590ec4&scoped=true&"
import script from "./divBorder.vue?vue&type=script&lang=js&"
export * from "./divBorder.vue?vue&type=script&lang=js&"
import style0 from "./divBorder.vue?vue&type=style&index=0&id=4b590ec4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b590ec4",
  null
  
)

export default component.exports